import {SPEARBIO_TROUGH_COLUMN} from 'contents/PlateTypeEditor/PlateTypeEditorEnum';

export const isOnSpearBioTrough = (column, columnTipCount = 1) => {
  const maxColumnForTrough = Math.max(...SPEARBIO_TROUGH_COLUMN);
  const startingColumnPosition = maxColumnForTrough - (column + (columnTipCount - 1));
  const isOnTrough = maxColumnForTrough - startingColumnPosition <= maxColumnForTrough;

  return isOnTrough;
};

export const _doNotUse = () => {};
